import React, { useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Container, Grid, IconButton } from "@mui/material";
import { AppBarComponent } from "../Components/AppBar";
import { useNavigate } from "react-router-dom";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  deleteTableDots,
  functions,
  instance,
  validateFunction,
} from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function TipoDeEje() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  deleteTableDots(2);
  function TipoDeEjeDetalle(id, nombre) {
    navigate("/TipoDeEjeDetalle", {
      state: { id: id, nombre: nombre },
    });
  }
  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
      size: 50,
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad de Ejes",
      size: 10,
    },
    {
      accessorFn: (row) => `${row.nombre}`, //accessorFn used to join multiple data into a single cell
      id: "name", //id is still required when using accessorFn instead of accessorKey
      header: "",
      size: 20,
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Button
            onClick={() =>
              TipoDeEjeDetalle(row.original.id, row.original.nombre)
            }
          >
            <InfoTwoToneIcon />
            <p className="IconButtonText">Ver más</p>
          </Button>
        </Box>
      ),
    },
  ]);

  if (isLoading) {
    async function getItems() {
      try {
        const { data } = await instance.get("/tipoDeEje");
        setItems(data);
      } catch (error) {
        alert(error);
      }
    }
    getItems();
    setLoading(false);
  }
  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxwidth=""
        sx={{
          marginTop: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <Grid container gap={{ xs: "0px", sm: "12px" }}>
            <Grid item xs={12} sm={12} md={12}>
              <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columns}
                data={items}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning={false}
                enableRowActions={false}
                initialState={{
                  showColumnFilters: false,
                  columnVisibility: { id: false },
                }}
                positionToolbarAlertBanner="none"
                enableColumnFilters={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enablePagination={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      /* gap: '1rem', p: '4px', */ justifyContent: "flex-end",
                    }}
                  >
                    {validateFunction(user, functions.CreateCatalog) && (
                      <IconButton
                        color="success"
                        onClick={() => {
                          navigate("/TipoDeEjeAgregar");
                        }}
                        variant="contained"
                      >
                        <AddCircleTwoToneIcon />
                        <p className="IconButtonText">Agregar</p>
                      </IconButton>
                    )}
                  </Box>
                )}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </LoaderBox>
  );
}

export { TipoDeEje };
